import * as React from "react";
import { RouteComponentProps, navigate } from "@reach/router";
import { useQuery } from "@apollo/client";
import { ContainerCard, LinkButton } from "components/haven-design";
import { UserDocuments, UserDocuments_viewer_documents as Document } from "types/gql-types";
import { LoadingSpinner } from "components/graphql-views";
import { documentsQuery as query } from "./queries";
import { formatUploadDate } from "./utls";
import styles from "./styles.module.css";

const DocumentList: React.FC<RouteComponentProps> = () => {
  const { data, loading, error } = useQuery<UserDocuments>(query);

  const handleClick = (document: Document) => () => {
    navigate(`documents/${document.id}`);
  };

  return (
    <ContainerCard className={styles.container}>
      <h1>My Documents</h1>

      <div className="flex">
        <LinkButton to="upload" color="primary" size="S">
          Upload Files
        </LinkButton>
      </div>

      <div className={styles.documents}>
        {loading && <LoadingSpinner />}

        {error && <div>Error loading documents. Please contact support@havenconnect.com</div>}

        {data?.viewer?.documents?.length === 0 && <div className={styles.empty}>No documents</div>}

        {data?.viewer?.documents?.map((doc) => (
          <div key={doc.id} className={styles.documentRow} onClick={handleClick(doc)}>
            <div className={styles.category} data-cy="upload-name">{doc.name}</div>
            <div className={styles.category}>{doc.category}</div>
            <div className={styles.timestamp}>{formatUploadDate(doc.uploadedAt)}</div>
          </div>
        ))}
      </div>
    </ContainerCard>
  );
};

export default DocumentList;
